import type { ReactNode, SVGProps } from "react";

export function ArrowMenuIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="13"
			viewBox="0 0 8 13"
			width="8"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0.625 3.625L3.625 0.625L6.625 3.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.625 9.125L3.625 12.125L0.625 9.125"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
